import { Map } from 'immutable';
import { rendererActionType } from 'constants/rendererActionType';
import { RendererState } from './rendererState';
/**
 *  Image gallery reducer
 */
export var rendererReducer = function (state, action) {
    if (state === void 0) { state = Map(new RendererState()); }
    var payload = action.payload;
    switch (action.type) {
        case rendererActionType.DISPLAY_SCENE:
            return state
                .set(['renderer', 'StateScene'], payload);
        case rendererActionType.ALERT:
            console.log(payload);
            return state;
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/renderers/rendererReducer.ts
// module id = 581
// module chunks = 50